import AuthenticatedUser from './AuthenticatedUser';
import ImpersonatingUser from './ImpersonatingUser';
import Subscription from './Subscription';

export default class AccessToken {
	token: string;

	user: AuthenticatedUser;

	impersonatedBy: ImpersonatingUser | null;

	subscription: Subscription | null;

	constructor(
		token: string,
		user: AuthenticatedUser,
		impersonatedBy: ImpersonatingUser | null,
		subscription: Subscription | null
	) {
		this.token = token;
		this.user = user;
		this.impersonatedBy = impersonatedBy;
		this.subscription = subscription;
	}
}
